import { render, staticRenderFns } from "./AddApparatusUpgradeFromLegacy.vue?vue&type=template&id=b5ca53d0"
import script from "./AddApparatusUpgradeFromLegacy.vue?vue&type=script&lang=js"
export * from "./AddApparatusUpgradeFromLegacy.vue?vue&type=script&lang=js"
import style0 from "./AddApparatusUpgradeFromLegacy.vue?vue&type=style&index=0&id=b5ca53d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports